<template>
    <div>
        <div class="header flex rcc">
            <div class="search">
                <img :src="Images.icon_search" alt="">
                <input type="text" placeholder="输入关键字搜素" v-model="keyword">
                <div></div>
                <p @click="refresh">搜索</p>
            </div>
        </div>
        <div class="scrollerView" :style="{ height: (wrapperHeight- 50) + 'px' }">
            <scroller :on-refresh="refresh" :on-infinite="infinite" :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''" ref="infinite" class="scroller">
                <courseRecordItem v-for="(item, index) in dataSources" :key="index" :item="item" />
                <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
            </scroller>
        </div>
    </div>
</template>
<script>
import courseRecordItem from '@/components/item/courseRecordItem'
export default {
    /** 组件挂载 */
    components: {
        'courseRecordItem': courseRecordItem,
    },
    /** 数据区 */
    data() {
        return {
            loading: true,
            wrapperHeight: 0, //屏幕高度 - 脚部
            page: 1,
            limit: 10,
            keyword: '',
            dataSources: [],
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
        this.requestData();
    },
    /** 方法 */
    methods: {
        refresh(done) {
            console.log('刷新');
            this.page = 1;
            this.requestData();
            setTimeout(() => {
                done()
            }, 1000)
        },
        infinite() {
            setTimeout(() => {
                this.page++
                this.requestData();
            }, 500);
        },
        // 列表数据
        async requestData() {
            let url = this.API.agent_subject_record;
            let params = {
                keyword: this.keyword,

                page: this.page,
                limit: this.limit
            };
            this.loading = true;
            let result = await this.$post(url, params);
            setTimeout(() => this.loading = false, 1000);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let list = result.data || []
                if (this.page === 1) {
                    this.dataSources = list
                } else {
                    this.dataSources = this.dataSources.concat(list)
                }
                this.$refs.infinite.finishInfinite(list.length < this.limit);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        }
    }
};
</script>
<style lang="less" scoped>
.scrollerView {
    position: relative;
    top: 0;
    width: 100%;
}

.header {
    height: 60px;
    padding: 0 1.5rem;
    background: #fff;
    position: relative;

    .left-btn {
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translateY(-50%);
        display: flex;
        justify-content: flex-start;
        align-items: center;

        img {
            display: block;
            height: 20px;
            opacity: .8;
        }
    }

    .search {
        flex: 1;
        padding: 0 10px;
        height: 34px;
        display: flex;
        align-items: center;
        background: #F5F5F5;
        border-radius: 5px;

        img {
            width: 14px;
            height: 14px;
        }

        input {
            flex: 1;
            margin-left: 10px;
            font-size: 14px;
            color: #333;
        }

        div {
            width: 1px;
            height: 15px;
            margin: 0 10px;
            background: #E1D9D9;
        }

        p {
            font-size: 14px;
            color: #666;
        }
    }
}
</style>